import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=0e00bf0f&scoped=true"
import script from "./NotificationManagement.vue?vue&type=script&lang=js"
export * from "./NotificationManagement.vue?vue&type=script&lang=js"
import style0 from "./NotificationManagement.vue?vue&type=style&index=0&id=0e00bf0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e00bf0f",
  null
  
)

export default component.exports